// AIS v5.2 - load more + carat fix
(function () {
  function init() {
    const API = (window.AIS_API_URL || "").replace(/\/$/, "");
    const grid = document.getElementById("ais-results");
    const loadMoreWrap = document.getElementById("ais-load-more-wrap");
    const transcriptEl = document.getElementById("ais-transcript");
    const statusEl = document.getElementById("ais-status");

    console.log("[AIS v5] grid:", grid, "loadMoreWrap:", loadMoreWrap);

    if (!grid || !loadMoreWrap) {
      console.warn("[AIS v5] Missing elements, aborting");
      return;
    }

    const METAL_KEY_ORDER = [
      "10k-white-gold",
      "10k-yellow-gold",
      "10k-rose-gold",
      "14k-white-gold",
      "14k-yellow-gold",
      "14k-rose-gold",
      "18k-white-gold",
      "18k-yellow-gold",
      "18k-rose-gold",
      "platinum",
      "silver",
    ];
    const KARAT_ORDER = ["10K", "14K", "18K", "PL"];

    let lastFilters = {};
    let currentPage = 1;
    let mediaRecorder = null;
    let isRecording = false;
    let _searchAbort = null;

    // ── Voice search ───────────────────────────────────────────────────────────
    const voiceBtn = document.getElementById("ais-voice-btn");
    if (voiceBtn) {
      voiceBtn.addEventListener("click", async () => {
        if (isRecording) {
          mediaRecorder && mediaRecorder.stop();
          return;
        }
        let stream;
        try {
          stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        } catch {
          setStatus("Microphone access denied.");
          return;
        }
        const chunks = [];
        mediaRecorder = new MediaRecorder(stream, { mimeType: "audio/webm" });
        mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
        mediaRecorder.onstop = async () => {
          stream.getTracks().forEach((t) => t.stop());
          isRecording = false;
          setVoiceBtn(false);
          voiceBtn.blur();
          setStatus("Transcribing…");
          const blob = new Blob(chunks, { type: "audio/webm" });
          const fd = new FormData();
          fd.append("audio", blob, "recording.webm");
          await streamSearch(`${API}/api/transcribe`, fd);
        };
        mediaRecorder.start();
        isRecording = true;
        setVoiceBtn(true);
        setStatus("Recording… click again to stop.");
      });
    }

    // ── Image search with inline crop ─────────────────────────────────────────
    const imageInput = document.getElementById("ais-image-input");
    let _cropImg = null,
      _cropCanvas = null,
      _cropCtx = null;
    let _cropSel = null,
      _isDragging = false,
      _dragStart = null;

    // Build inline crop container once and insert before the results grid
    const _cropWrap = document.createElement("div");
    _cropWrap.id = "ais-crop-wrap";
    _cropWrap.style.cssText =
      "display:none;flex-direction:column;align-items:center;gap:12px;padding:20px 0 24px;width:100%;";
    _cropWrap.innerHTML = `
    <canvas id="ais-crop-canvas" style="cursor:crosshair;display:block;max-width:100%;border:1px solid #ddd;box-shadow:0 2px 12px rgba(0,0,0,.1);"></canvas>
    <div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap;justify-content:center;">
      <span style="font-size:12px;color:#888;">Drag to select a crop area</span>
      <button id="ais-crop-replace-btn" style="padding:9px 22px;background:transparent;color:#333;border:1px solid #333;cursor:pointer;font-size:13px;letter-spacing:0.04em;">Replace Image</button>
    </div>`;
    grid.parentElement.insertBefore(_cropWrap, grid);

    _cropCanvas = document.getElementById("ais-crop-canvas");
    _cropCtx = _cropCanvas.getContext("2d");

    const _getCropPos = (e) => {
      const r = _cropCanvas.getBoundingClientRect();
      return {
        x: Math.max(
          0,
          Math.min(
            _cropCanvas.width,
            (e.clientX - r.left) * (_cropCanvas.width / r.width),
          ),
        ),
        y: Math.max(
          0,
          Math.min(
            _cropCanvas.height,
            (e.clientY - r.top) * (_cropCanvas.height / r.height),
          ),
        ),
      };
    };

    _cropCanvas.addEventListener("mousedown", (e) => {
      _dragStart = _getCropPos(e);
      _isDragging = true;
      _cropSel = null;
    });
    _cropCanvas.addEventListener("mousemove", (e) => {
      if (!_isDragging) return;
      const p = _getCropPos(e);
      _cropSel = {
        x: Math.min(_dragStart.x, p.x),
        y: Math.min(_dragStart.y, p.y),
        w: Math.abs(p.x - _dragStart.x),
        h: Math.abs(p.y - _dragStart.y),
      };
      _drawCrop();
    });
    const _endDrag = () => {
      if (!_isDragging) return;
      _isDragging = false;
      if (_cropSel && (_cropSel.w < 8 || _cropSel.h < 8)) {
        _cropSel = null;
        _drawCrop();
        return;
      }
      if (_cropSel) _fireCropSearch();
    };
    _cropCanvas.addEventListener("mouseup", _endDrag);
    _cropCanvas.addEventListener("mouseleave", _endDrag);
    _cropCanvas.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault();
        _dragStart = _getCropPos(e.touches[0]);
        _isDragging = true;
        _cropSel = null;
      },
      { passive: false },
    );
    _cropCanvas.addEventListener(
      "touchmove",
      (e) => {
        e.preventDefault();
        if (!_isDragging) return;
        const p = _getCropPos(e.touches[0]);
        _cropSel = {
          x: Math.min(_dragStart.x, p.x),
          y: Math.min(_dragStart.y, p.y),
          w: Math.abs(p.x - _dragStart.x),
          h: Math.abs(p.y - _dragStart.y),
        };
        _drawCrop();
      },
      { passive: false },
    );
    _cropCanvas.addEventListener(
      "touchend",
      (e) => {
        e.preventDefault();
        _endDrag();
      },
      { passive: false },
    );

    document
      .getElementById("ais-crop-replace-btn")
      .addEventListener("click", () => {
        imageInput && imageInput.click();
      });

    function _drawCrop() {
      if (!_cropCtx || !_cropImg) return;
      const cw = _cropCanvas.width,
        ch = _cropCanvas.height;
      _cropCtx.clearRect(0, 0, cw, ch);
      _cropCtx.drawImage(_cropImg, 0, 0, cw, ch);
      if (_cropSel && _cropSel.w > 0 && _cropSel.h > 0) {
        const { x, y, w, h } = _cropSel;
        _cropCtx.fillStyle = "rgba(0,0,0,.45)";
        _cropCtx.fillRect(0, 0, cw, ch);
        const sx = _cropImg.naturalWidth / cw,
          sy = _cropImg.naturalHeight / ch;
        _cropCtx.drawImage(
          _cropImg,
          x * sx,
          y * sy,
          w * sx,
          h * sy,
          x,
          y,
          w,
          h,
        );
        _cropCtx.strokeStyle = "#fff";
        _cropCtx.lineWidth = 2;
        _cropCtx.setLineDash([5, 3]);
        _cropCtx.strokeRect(x, y, w, h);
        _cropCtx.setLineDash([]);
      }
    }

    async function _fireCropSearch() {
      if (!_cropImg) return;
      const off = document.createElement("canvas");
      const octx = off.getContext("2d");
      const sx = _cropImg.naturalWidth / _cropCanvas.width,
        sy = _cropImg.naturalHeight / _cropCanvas.height;
      if (_cropSel && _cropSel.w > 8 && _cropSel.h > 8) {
        off.width = Math.round(_cropSel.w * sx);
        off.height = Math.round(_cropSel.h * sy);
        octx.drawImage(
          _cropImg,
          _cropSel.x * sx,
          _cropSel.y * sy,
          off.width,
          off.height,
          0,
          0,
          off.width,
          off.height,
        );
      } else {
        off.width = _cropImg.naturalWidth;
        off.height = _cropImg.naturalHeight;
        octx.drawImage(_cropImg, 0, 0);
      }
      setStatus("Analyzing image…");
      off.toBlob(
        async (blob) => {
          const fd = new FormData();
          fd.append("image", blob, "crop.jpg");
          await streamSearch(`${API}/api/image-search`, fd);
        },
        "image/jpeg",
        0.92,
      );
    }

    if (imageInput) {
      imageInput.addEventListener("change", async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        e.target.value = "";

        // Fire search immediately with the full image
        setStatus("Analyzing image…");
        const fd = new FormData();
        fd.append("image", file);
        streamSearch(`${API}/api/image-search`, fd);

        // Load image into inline crop container
        const img = new Image();
        img.onload = () => {
          _cropImg = img;
          _cropSel = null;
          const maxW = Math.min(window.innerWidth * 0.44, 620);
          const maxH = Math.min(window.innerHeight * 0.8, 720);
          const scale = Math.min(
            1,
            maxW / img.naturalWidth,
            maxH / img.naturalHeight,
          );
          _cropCanvas.width = Math.round(img.naturalWidth * scale);
          _cropCanvas.height = Math.round(img.naturalHeight * scale);
          _drawCrop();
          _cropWrap.style.display = "flex";
          grid.parentElement.classList.add("ais-crop-active");
        };
        img.src = URL.createObjectURL(file);
      });
    }

    // Allow external callers (e.g. quick-search bar) to trigger image search
    window.AIS_handleImageFile = function (file) {
      setStatus("Analyzing image…");
      const fd = new FormData();
      fd.append("image", file);
      streamSearch(`${API}/api/image-search`, fd);
      const img = new Image();
      img.onload = () => {
        _cropImg = img;
        _cropSel = null;
        const maxW = Math.min(window.innerWidth * 0.44, 620);
        const maxH = Math.min(window.innerHeight * 0.8, 720);
        const scale = Math.min(
          1,
          maxW / img.naturalWidth,
          maxH / img.naturalHeight,
        );
        _cropCanvas.width = Math.round(img.naturalWidth * scale);
        _cropCanvas.height = Math.round(img.naturalHeight * scale);
        _drawCrop();
        _cropWrap.style.display = "flex";
        grid.parentElement.classList.add("ais-crop-active");
      };
      img.src = URL.createObjectURL(file);
    };

    // ── SSE streaming ──────────────────────────────────────────────────────────
    async function streamSearch(url, formData) {
      if (_searchAbort) _searchAbort.abort();
      _searchAbort = new AbortController();
      const signal = _searchAbort.signal;

      _imageSearchType = null;
      _isImageSearch = url.includes("image-search");
      _lastDescription = "";
      _pendingResults = null;
      _activeDetectedMetal = null;
      grid.innerHTML = "";
      loadMoreWrap.innerHTML = "";
      if (transcriptEl) transcriptEl.textContent = "";
      try {
        const resp = await fetch(url, {
          method: "POST",
          body: formData,
          signal,
        });
        if (!resp.ok) {
          setStatus(`Error ${resp.status}`);
          return;
        }
        const reader = resp.body.getReader();
        const decoder = new TextDecoder();
        let buffer = "";
        let currentEvent = null;
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split("\n");
          buffer = lines.pop();
          for (const line of lines) {
            if (line.startsWith("event: ")) {
              currentEvent = line.slice(7).trim();
              continue;
            }
            if (line.startsWith("data: ") && currentEvent) {
              try {
                handleEvent(currentEvent, JSON.parse(line.slice(6)));
              } catch {}
              currentEvent = null;
            }
          }
        }
        // Stream ended — if results arrived before description, render now
        if (_pendingResults !== null) {
          processResults(_pendingResults);
          _pendingResults = null;
        }
      } catch (err) {
        if (err.name !== "AbortError")
          setStatus(`Network error: ${err.message}`);
      }
    }

    const PAGE_SIZE = 16;
    let allResults = [];

    // Ordered so 'earring' is checked before 'ring' (earring contains "ring")
    const JEWELRY_TYPES = [
      "earring",
      "necklace",
      "bracelet",
      "pendant",
      "bangle",
      "anklet",
      "brooch",
      "ring",
    ];
    // Groups so necklace/pendant and bracelet/bangle match each other's product tags
    const TYPE_SYNONYMS = {
      necklace: ["necklace", "pendant", "chain"],
      pendant: ["necklace", "pendant", "chain"],
      bracelet: ["bracelet", "bangle"],
      bangle: ["bracelet", "bangle"],
      earring: ["earring"],
      ring: ["ring"],
      anklet: ["anklet"],
      brooch: ["brooch"],
    };
    let _imageSearchType = null;
    let _isImageSearch = false;
    let _lastDescription = "";
    let _pendingResults = null;
    let _activeDetectedMetal = null;

    // Extended patterns — direct type words + body-part / usage clues
    const TYPE_PATTERNS = {
      earring:  [/\bearring\b/g, /\bear\s+ring\b/g, /\bhoop\b/g, /\bear\s+stud\b/g, /\bstud\s+ear/g, /\bdrop\s+ear/g],
      necklace: [/\bnecklace\b/g, /\baround\s+(?:the\s+)?neck\b/g, /\bneck\s+jewelry\b/g, /\bchoker\b/g, /\blariat\b/g, /\bchain\s+neck/g, /\bneck\s+chain\b/g],
      bracelet: [/\bbracelet\b/g, /\bbangle\b/g, /\bwrist\b/g, /\bcuff\b/g, /\barm\s+(?:band|piece|jewelry)\b/g, /\btennis\s+bracelet\b/g],
      pendant:  [/\bpendant\b/g, /\bhanging\s+charm\b/g, /\bneck\s+pendant\b/g],
      ring:     [/\bring\b/g, /\bfinger\s+(?:ring|jewelry)\b/g, /\bengagement\s+ring\b/g, /\bwedding\s+band\b/g, /\beternity\b/g, /\bsolitaire\b/g, /\bband\s+ring\b/g],
      brooch:   [/\bbrooch\b/g, /\bbroach\b/g, /\blapel\s+pin\b/g],
      anklet:   [/\banklet\b/g, /\bankle\s+(?:bracelet|jewelry)\b/g],
    };

    function _styleToType(style) {
      if (!style) return null;
      const s = style.toLowerCase();
      if (s === 'hoops' || s === 'studs' || s.includes('earring')) return 'earring';
      if (s.includes('necklace') || s.includes('pendant')) return 'necklace';
      if (s === 'bangle' || s.includes('bracelet')) return 'bracelet';
      if (s.includes('ring') || s.includes('band')) return 'ring';
      return null;
    }

    function _parseMetalColor(metal) {
      if (!metal) return null;
      const m = metal.toLowerCase();
      if (m.includes('rose')) return 'rose';
      if (m.includes('white')) return 'white';
      if (m.includes('yellow')) return 'yellow';
      if (m.includes('platinum')) return 'platinum';
      return null;
    }

    function _detectJewelryType(text) {
      const lower = (text || "").toLowerCase();
      let bestType = null, bestCount = 0;
      for (const [type, patterns] of Object.entries(TYPE_PATTERNS)) {
        let count = 0;
        for (const re of patterns) count += (lower.match(re) || []).length;
        if (count > bestCount) { bestCount = count; bestType = type; }
      }
      return bestType;
    }

    // Checks all field names the server might use to send the jewelry type explicitly
    function _extractServerType(data) {
      return data.jewelry_type || data.type || data.category ||
             data.jewelryType || data.product_type || data.productType || null;
    }

    // Last-resort: infer type from majority of product tags/titles in results
    function _inferTypeFromResults(results) {
      const counts = {};
      for (const p of (results || [])) {
        const haystack = [
          p.title || "", p.product_type || "", p.type || "",
          ...(Array.isArray(p.tags) ? p.tags : String(p.tags || "").split(",")),
        ].join(" ").toLowerCase();
        for (const [type, patterns] of Object.entries(TYPE_PATTERNS)) {
          let c = 0;
          for (const re of patterns) c += (haystack.match(re) || []).length;
          counts[type] = (counts[type] || 0) + c;
        }
      }
      let bestType = null, bestCount = 0;
      for (const [t, n] of Object.entries(counts)) {
        if (n > bestCount) { bestCount = n; bestType = t; }
      }
      return bestType;
    }

    function _productMatchesType(p, type) {
      if (!type) return true;
      const haystack = [
        p.title || "",
        p.product_type || "",
        p.type || "",
        ...(Array.isArray(p.tags) ? p.tags : String(p.tags || "").split(",")),
      ]
        .join(" ")
        .toLowerCase();
      const keywords = TYPE_SYNONYMS[type] || [type];
      return keywords.some((k) =>
        k === "ring" ? /\bring\b/.test(haystack) : haystack.includes(k),
      );
    }

    function processResults(data) {
      if (data.notRelevant) {
        grid.innerHTML = `<p style="text-align:center;padding:40px 0;color:#888;width:100%;">Please upload a jewelry image to search.</p>`;
        loadMoreWrap.innerHTML = "";
        setStatus("");
        return;
      }
      lastFilters = data.filters || {};
      currentPage = 1;
      allResults = (data.results || []).filter((p) => {
        const tags = Array.isArray(p.tags)
          ? p.tags
          : String(p.tags || "")
              .split(",")
              .map((t) => t.trim());
        if (tags.includes("dyo_rings")) return false;
        return _productMatchesType(p, _imageSearchType);
      });
      const total = allResults.length;
      if (total === 0) {
        grid.innerHTML = `<p style="text-align:center;padding:40px 0;color:#888;width:100%;">No products found.</p>`;
        loadMoreWrap.innerHTML = "";
        setStatus("");
        return;
      }
      setStatus(`${total} result${total !== 1 ? "s" : ""}`);
      const firstPage = allResults.slice(0, PAGE_SIZE);
      const hasMore =
        data.hasMore === true ||
        total > PAGE_SIZE ||
        allResults.length > PAGE_SIZE;
      renderResults(firstPage, false);
      renderLoadMore({ ...data, total, hasMore });
    }

    function handleEvent(event, data) {
      if (event === "transcription" && transcriptEl)
        transcriptEl.textContent = `"${data.transcription}"`;
      if (event === "description") {
        setStatus(data.description);
        _lastDescription = data.description;
        // For voice search only — detect type from description to assist filtering
        if (!_isImageSearch) {
          _imageSearchType = _extractServerType(data) || _detectJewelryType(data.description);
        }
        if (_pendingResults !== null) {
          processResults(_pendingResults);
          _pendingResults = null;
        }
      }
      if (event === "results") {
        if (_isImageSearch) {
          _imageSearchType = _styleToType(data.detectedStyle);
          _activeDetectedMetal = _parseMetalColor(data.detectedMetal);
          processResults(data);
        } else if (!_imageSearchType) {
          _pendingResults = data;
        } else {
          processResults(data);
        }
      }
      if (event === "error") setStatus(data.error || "Something went wrong. Please try again.");
    }

    // ── Render ─────────────────────────────────────────────────────────────────
    function renderResults(products, append) {
      const html = products
        .map((p, i) => renderCard(p, append ? currentPage * 16 + i : i))
        .join("");
      if (append) grid.insertAdjacentHTML("beforeend", html);
      else grid.innerHTML = html;
      initSwatchInteractions();
    }

    function renderCard(p, index) {
      const handle = p.handle || p.product_id;
      const url = `/products/${handle}`;
      const price = p.price?.amount || 0;
      const compareAt = p.price?.compare_at || 0;
      const isOnSale = compareAt > price && compareAt > 0;
      const firstVariantId = p.variants?.[0]?.id || "";
      const mainImage = p.image || "";
      // Find a second image of the same metal as the default variant (not a different metal)
      const defaultMetalKey = handleize(p.variants?.[0]?.metal?.type || "");
      const hoverImage =
        p.image2 ||
        (p.variants || [])
          .filter((v) => handleize(v.metal?.type || "") === defaultMetalKey)
          .find((v) => v.image && v.image !== mainImage)?.image || "";
      const hasMultipleImages = !!hoverImage;
      const fmt = (n) =>
        "$" + Number(n).toLocaleString("en-US", { minimumFractionDigits: 0 });
      const discountPct = isOnSale
        ? Math.round((1 - price / compareAt) * 100)
        : 0;

      return `
<div class="product-item animation animation--item animation--item-revealed animation--item-initial"
     style="--z-index-item:${index};"
     data-product-id="${p.product_id}"
     data-product-price="${price > 0 ? fmt(price) : ""}"
     data-product-compare-price="${isOnSale ? fmt(compareAt) : ""}">
  <div class="product-item__inner">
    <div class="product-item__media${hasMultipleImages ? " product-item__media--multiple-images" : ""}">
      <div class="wishlist-engine ${firstVariantId}"
           data-product_id="${p.product_id}"
           data-variant_id="${firstVariantId}"
           data-full_button="false"
           data-css="true"></div>
      <a class="product-item__image-link" href="${url}" aria-label="${p.title}">
        <div class="image product-item__image${hasMultipleImages ? " product-item__image--one" : ""}${window.AIS_ASPECT_RATIO && window.AIS_ASPECT_RATIO !== "natural" ? " aspect-ratio--" + window.AIS_ASPECT_RATIO : ""}">
          <img src="${mainImage}" alt="${p.title}" loading="lazy" width="600" height="600">
        </div>
        ${
          hasMultipleImages
            ? `
        <div class="image product-item__image product-item__image--two${window.AIS_ASPECT_RATIO && window.AIS_ASPECT_RATIO !== "natural" ? " aspect-ratio--" + window.AIS_ASPECT_RATIO : ""}">
          <img src="${hoverImage}" alt="${p.title}" loading="lazy" width="600" height="600">
        </div>`
            : ""
        }
      </a>
    </div>
    <div class="product-item__meta">
      <div class="product-item__text ta-c">
        ${renderMetalSwatches(p)}
        <div class="product-item-heading-wrapper">
          <h4 class="ff-body product-item__product-title fs-product-card-title">
            <a id="dynamic-id-${handle}" href="${url}">${p.title}</a>
          </h4>
          <div class="price-star-wrapper">
            ${isOnSale ? `<p class="product-item-compare-price">${fmt(compareAt)}</p>` : ""}
            <p class="product-item__price">
              <a href="${url}" class="price-prod">
                ${
                  isOnSale
                    ? `<span class="sale" data-price>${fmt(price)}</span>`
                    : `<span class="product-item__price" data-price>${fmt(price)}</span>`
                }
              </a>
            </p>
            ${isOnSale && discountPct > 0 ? `<span class="collectionpage_discount_badge">-${discountPct}%</span>` : ""}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`;
    }

    // ── Metal swatches HTML ────────────────────────────────────────────────────
    function renderMetalSwatches(p) {
      const variants = p.variants || [];
      const variantsByKey = new Map();
      for (const v of variants) {
        const key = handleize(v.metal?.type || "");
        if (key && !variantsByKey.has(key)) variantsByKey.set(key, v);
      }
      const orderedSwatches = METAL_KEY_ORDER.filter((k) =>
        variantsByKey.has(k),
      ).map((k) => ({ key: k, variant: variantsByKey.get(k) }));

      const seenKarats = new Set();
      for (const { variant } of orderedSwatches) {
        const k = toKaratLabel(variant.metal?.type || "");
        if (k) seenKarats.add(k);
      }
      const orderedKarats = KARAT_ORDER.filter((k) => seenKarats.has(k));
      const defaultKarat = orderedKarats[0] || "";

      if (orderedSwatches.length === 0 && !hasCaratVariants(p)) return "";

      const COLOR_BUCKETS = ["white", "yellow", "rose", "platinum"];
      const KEY_TO_BUCKET = {
        "10k-white-gold": "white",
        "14k-white-gold": "white",
        "18k-white-gold": "white",
        "10k-yellow-gold": "yellow",
        "14k-yellow-gold": "yellow",
        "18k-yellow-gold": "yellow",
        "10k-rose-gold": "rose",
        "14k-rose-gold": "rose",
        "18k-rose-gold": "rose",
        platinum: "platinum",
        silver: "platinum",
      };
      const bucketKaratMap = {};
      for (const { key, variant } of orderedSwatches) {
        const bucket = KEY_TO_BUCKET[key];
        const karat = toKaratLabel(variant.metal?.type || "");
        if (!bucket || !karat) continue;
        if (!bucketKaratMap[bucket]) bucketKaratMap[bucket] = {};
        if (!bucketKaratMap[bucket][karat])
          bucketKaratMap[bucket][karat] = variant;
      }
      const availableBuckets = COLOR_BUCKETS.filter((b) => bucketKaratMap[b]);

      const preferredBucket = _activeDetectedMetal && availableBuckets.includes(_activeDetectedMetal)
        ? _activeDetectedMetal
        : availableBuckets[0];
      const swatchItemsHtml = availableBuckets
        .map((bucket) => {
          const karatVariants = bucketKaratMap[bucket];
          const variantDataByKarat = {};
          for (const [karat, v] of Object.entries(karatVariants)) {
            variantDataByKarat[karat] = {
              image: v.image || "",
              image2: v.image2 || "",
              price:
                v.price?.amount != null
                  ? "$" +
                    Number(v.price.amount).toLocaleString("en-US", {
                      minimumFractionDigits: 0,
                    })
                  : "",
              comparePrice:
                v.price?.compare_at > v.price?.amount
                  ? "$" +
                    Number(v.price.compare_at).toLocaleString("en-US", {
                      minimumFractionDigits: 0,
                    })
                  : "",
              metalName: v.metal?.type || "",
            };
          }
          const swatchKey =
            bucket === "white"
              ? `${defaultKarat.toLowerCase()}-white-gold`
              : bucket === "yellow"
                ? `${defaultKarat.toLowerCase()}-yellow-gold`
                : bucket === "rose"
                  ? `${defaultKarat.toLowerCase()}-rose-gold`
                  : "platinum";
          const { normalUrl, hoverUrl } = getSwatchImages(swatchKey);
          const startV =
            variantDataByKarat[defaultKarat] ||
            Object.values(variantDataByKarat)[0] ||
            {};
          // Fallback for variants missing a synced second image: borrow another
          // karat's differing photo within the same color bucket.
          const bucketHoverImage =
            Object.values(variantDataByKarat)
              .map((v) => v.image)
              .find((img) => img && img !== startV.image) || "";
          for (const karat of Object.keys(variantDataByKarat)) {
            variantDataByKarat[karat].hoverImage =
              variantDataByKarat[karat].image2 || bucketHoverImage;
          }
          const isActive = bucket === preferredBucket;

          return `
        <div class="product-swatches-options__item--metal--wrapper" style="display:flex;">
          <div class="product-swatches-options__item
                      product-swatches-options__item--metal
                      product-swatches-options__item--metal--${p.product_id}
                      product-swatches-options__item--swatch${isActive ? " active" : ""}"
               data-swatch-bucket="${bucket}"
               data-swatch-product-id="${p.product_id}"
               data-swatch-karat="${defaultKarat}"
               data-variant-data='${JSON.stringify(variantDataByKarat).replace(/'/g, "&#39;")}'
               data-variant-image="${startV.image || ""}"
               data-variant-price="${startV.price || ""}"
               data-variant-compare-price="${startV.comparePrice || ""}"
               data-hover-bg="${hoverUrl}"
               data-normal-bg="${normalUrl}"
               style="background-image: url(${normalUrl});">
          </div>
        </div>`;
        })
        .join("");

      const karatOptionsHtml = orderedKarats
        .map(
          (k, i) => `
      <div class="metalTypeDropdownOption${i === 0 ? " active" : ""}"
           data-swatch-karatvalue="${k}"
           data-swatch-productid="${p.product_id}">${k}</div>`,
        )
        .join("");

      const karatDropdownHtml =
        orderedKarats.length > 0
          ? `
      <div class="swatches-parent-wrapper metal-wrapper">
        <div class="metalKarat-swatches-parent-wrapper--button"
             data-swatch-id="${p.product_id}">
          ${defaultKarat}
        </div>
        <div class="metalKarat-swatches-parent-wrapper--popup product-swatches-options__list metalTypeDropdownOptions">
          ${karatOptionsHtml}
        </div>
      </div>`
          : "";

      const variantLookup = (p.variants || []).map((v) => ({
        metal: handleize(v.metal?.type || ""),
        carat: v.stones?.[0]?.carat ?? null,
        price:
          v.price?.amount != null
            ? "$" +
              Number(v.price.amount).toLocaleString("en-US", {
                minimumFractionDigits: 0,
              })
            : "",
        comparePrice:
          v.price?.compare_at != null && v.price.compare_at > v.price.amount
            ? "$" +
              Number(v.price.compare_at).toLocaleString("en-US", {
                minimumFractionDigits: 0,
              })
            : "",
        image: v.image || "",
      }));

      return `
      <div class="product-item-swatches-wrapper" data-variants="${encodeURIComponent(JSON.stringify(variantLookup))}">
        <div class="product-swatches-options__list product-metals-options product-metals-${p.product_id}">
          ${swatchItemsHtml}
        </div>
        ${karatDropdownHtml}
        ${renderCaratSwatches(p)}
      </div>`;
    }

    function getSwatchImages(key) {
      const urls = window.AIS_SWATCH_URLS || {};
      let normalUrl = "",
        hoverUrl = "";
      if (!key) return { normalUrl, hoverUrl };
      if (key.includes("platinum") || key === "platinum") {
        normalUrl = urls["Platinum_New"] || "";
        hoverUrl = normalUrl;
      } else if (key.includes("white")) {
        normalUrl = urls["White_Gold"] || "";
        hoverUrl = urls[key] || normalUrl;
      } else if (key.includes("rose")) {
        normalUrl = urls["Rose_Gold"] || "";
        hoverUrl = urls[key] || normalUrl;
      } else if (key.includes("yellow")) {
        normalUrl = urls["Yellow_Gold"] || "";
        hoverUrl = urls[key] || normalUrl;
      } else if (key === "silver") {
        normalUrl = urls["silver"] || "";
        hoverUrl = normalUrl;
      } else {
        normalUrl = urls[key] || "";
        hoverUrl = normalUrl;
      }
      return { normalUrl, hoverUrl };
    }

    function hasCaratVariants(p) {
      return (p.variants || []).some((v) => v.stones?.[0]?.carat != null);
    }

    function renderCaratSwatches(p) {
      const caratMap = new Map();
      for (const v of p.variants || []) {
        const carat = v.stones?.[0]?.carat;
        if (carat != null && !caratMap.has(Number(carat)))
          caratMap.set(Number(carat), v);
      }
      if (caratMap.size === 0) return "";
      const sorted = [...caratMap.keys()].sort((a, b) => a - b);
      const defaultCarat = sorted[0];
      const fmt = (c) =>
        Number(c) % 1 === 0 ? Number(c).toFixed(2) : c.toString();

      const caratItems = sorted
        .map((carat, i) => {
          const label = fmt(carat);
          return `
        <div class="caret-swatch-item product-swatches-options__item${i === 0 ? " active" : ""}"
             data-swatch-value="${label.replace(".", "-")}"
             data-swatch-name="${label}"
             value="${label.replace(".", "-")}">${label}</div>`;
        })
        .join("");

      return `
      <div class="swatches-parent-wrapper">
        <div class="carat-swatches-parent-wrapper--button" data-swatch-id="${p.product_id}">
          ${fmt(defaultCarat)}
        </div>
        <div class="carat-swatches-parent-wrapper--popup product-swatches-options__list product-carats-options product-carats-${p.product_id} product-swatches-${p.product_id}">
          <div class="product-carats-options-wrapper">
            ${caratItems}
          </div>
        </div>
      </div>`;
    }

    // ── All interactions: dropdowns + image/price switching ────────────────────
    function initSwatchInteractions() {
      // Close all open dropdowns when clicking outside
      document.addEventListener("click", closeAllDropdowns);

      grid.querySelectorAll("[data-product-id]").forEach((card) => {
        if (card.dataset.swatchInit) return;
        card.dataset.swatchInit = "1";

        // Prevent theme's swatch JS from repositioning our popup elements
        card
          .querySelectorAll(
            ".metalKarat-swatches-parent-wrapper--popup, .carat-swatches-parent-wrapper--popup",
          )
          .forEach((el) => {
            el.dataset.dropdownInitialized = "true";
            el.dataset.karatInitialized = "true";
          });

        const swatches = card.querySelectorAll(
          ".product-swatches-options__item--swatch",
        );
        const mainImg = card.querySelector(
          ".product-item__image--one img, .product-item__image img",
        );
        const hoverImg = card.querySelector(".product-item__image--two img");
        const mediaEl = card.querySelector(".product-item__media");
        const priceEl = card.querySelector("[data-price]");
        const comparePriceEl = card.querySelector(
          ".product-item-compare-price",
        );

        // Preload images
        swatches.forEach((s) => {
          try {
            Object.values(JSON.parse(s.dataset.variantData || "{}")).forEach(
              (v) => {
                if (v.image) new Image().src = v.image;
              },
            );
          } catch {}
        });

        let selectedSwatch =
          card.querySelector(
            ".product-swatches-options__item--swatch.active",
          ) || swatches[0];
        let selectedKarat =
          card.querySelector(".metalTypeDropdownOption.active")?.dataset
            .swatchKaratvalue ||
          card
            .querySelector(".metalKarat-swatches-parent-wrapper--button")
            ?.textContent.trim() ||
          "";

        // Parse the full variant lookup table (metal + carat → price/image)
        let variantLookup = [];
        try {
          const wrapper = card.querySelector(".product-item-swatches-wrapper");
          if (wrapper?.dataset.variants)
            variantLookup = JSON.parse(
              decodeURIComponent(wrapper.dataset.variants),
            );
        } catch {}

        // Current selected carat weight (null = no filter)
        let selectedCarat = null;
        const firstActiveCarat = card.querySelector(
          ".caret-swatch-item.active",
        );
        if (firstActiveCarat)
          selectedCarat = parseFloat(firstActiveCarat.dataset.swatchName);

        // Build metal key from color bucket + karat (e.g. 'white' + '14K' → '14k-white-gold')
        function bucketToMetalKey(bucket, karat) {
          if (bucket === "platinum") return "platinum";
          const k = karat.replace("K", "k").toLowerCase();
          return `${k}-${bucket}-gold`;
        }

        // Look up a variant by metal key + carat; falls back to metal key only
        function lookupVariant(metalKey, carat) {
          if (!variantLookup.length) return null;
          const withCarat =
            carat != null
              ? variantLookup.find(
                  (v) => v.metal === metalKey && v.carat === carat,
                )
              : null;
          return (
            withCarat || variantLookup.find((v) => v.metal === metalKey) || null
          );
        }

        function applyVariant(swatch, karat) {
          if (!swatch) return;
          // Primary: per-swatch variantData keyed by karat — guaranteed correct for metal+karat
          let v = null;
          try {
            const data = JSON.parse(swatch.dataset.variantData || "{}");
            v = data[karat] || Object.values(data)[0];
          } catch {}
          if (!v) return;

          // If a specific stone carat is selected, try to override price from the full lookup table
          if (selectedCarat != null && variantLookup.length) {
            const bucket = swatch.dataset.swatchBucket;
            if (bucket) {
              const metalKey = bucketToMetalKey(bucket, karat);
              const caratMatch = variantLookup.find(
                (item) =>
                  item.metal === metalKey && item.carat === selectedCarat,
              );
              if (caratMatch)
                v = {
                  ...v,
                  price: caratMatch.price,
                  comparePrice: caratMatch.comparePrice,
                };
            }
          }

          if (mainImg && v.image) mainImg.src = v.image;
          if (hoverImg) {
            if (v.hoverImage) {
              hoverImg.src = v.hoverImage;
              mediaEl?.classList.add("product-item__media--multiple-images");
            } else {
              mediaEl?.classList.remove("product-item__media--multiple-images");
            }
          }
          const displayPrice = v.price || card.dataset.productPrice || "";
          const displayCompare =
            v.comparePrice || card.dataset.productComparePrice || "";
          if (priceEl && displayPrice) priceEl.textContent = displayPrice;
          if (comparePriceEl) {
            comparePriceEl.textContent = displayCompare;
            comparePriceEl.style.display = displayCompare ? "" : "none";
          }
        }

        applyVariant(selectedSwatch, selectedKarat);

        // Sync karat dropdown to the first karat available for the given swatch.
        // Needed for platinum which only has 'PL', not '14K' etc.
        const syncKaratForSwatch = (swatch) => {
          if (!karatBtn) return;
          let data = {};
          try {
            data = JSON.parse(swatch.dataset.variantData || "{}");
          } catch {}
          const availableKarats = Object.keys(data);
          if (!availableKarats.length) return;
          // Use current karat if available, otherwise fall back to first available
          const karat = availableKarats.includes(selectedKarat)
            ? selectedKarat
            : availableKarats[0];
          if (karat !== selectedKarat) {
            selectedKarat = karat;
            karatBtn.textContent = karat;
            card.querySelectorAll(".metalTypeDropdownOption").forEach((o) => {
              o.classList.toggle(
                "active",
                o.dataset.swatchKaratvalue === karat,
              );
            });
          }
        };

        // ── Color swatch click/hover ──────────────────────────────────────────
        swatches.forEach((swatch) => {
          swatch.addEventListener("mouseenter", () => {
            if (swatch !== selectedSwatch) applyVariant(swatch, selectedKarat);
          });
          swatch.addEventListener("mouseleave", () =>
            applyVariant(selectedSwatch, selectedKarat),
          );
          swatch.addEventListener("click", () => {
            swatches.forEach((s) => s.classList.remove("active"));
            swatch.classList.add("active");
            selectedSwatch = swatch;
            syncKaratForSwatch(swatch);
            applyVariant(swatch, selectedKarat);
          });
        });

        // ── Karat dropdown ────────────────────────────────────────────────────
        const karatBtn = card.querySelector(
          ".metalKarat-swatches-parent-wrapper--button",
        );
        const karatPopup = card.querySelector(
          ".metalKarat-swatches-parent-wrapper--popup",
        );
        const karatOptions = card.querySelectorAll(".metalTypeDropdownOption");

        if (karatBtn && karatPopup) {
          karatBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            const isOpen = karatPopup.classList.contains("popup-visible");
            closeAllDropdowns();
            if (!isOpen) {
              openPopup(karatBtn, karatPopup);
              karatBtn.classList.add(
                "metalKarat-swatches-parent-wrapper--button--upArrow",
              );
            }
          });

          karatOptions.forEach((opt) => {
            opt.addEventListener("click", (e) => {
              e.stopPropagation();
              selectedKarat = opt.dataset.swatchKaratvalue;
              karatBtn.innerHTML = selectedKarat;
              karatOptions.forEach((o) => o.classList.remove("active"));
              opt.classList.add("active");

              // PL means platinum metal, not a gold karat — activate the platinum swatch
              if (selectedKarat === "PL") {
                const platinumSwatch = [...swatches].find(
                  (s) => s.dataset.swatchBucket === "platinum",
                );
                if (platinumSwatch) {
                  swatches.forEach((s) => s.classList.remove("active"));
                  platinumSwatch.classList.add("active");
                  selectedSwatch = platinumSwatch;
                }
              }

              applyVariant(selectedSwatch, selectedKarat);
              karatPopup.classList.remove("popup-visible");
              karatBtn.classList.remove(
                "metalKarat-swatches-parent-wrapper--button--upArrow",
              );
            });
          });
        }

        // ── Carat dropdown ────────────────────────────────────────────────────
        const caratBtn = card.querySelector(
          ".carat-swatches-parent-wrapper--button",
        );
        const caratPopup = card.querySelector(
          ".carat-swatches-parent-wrapper--popup",
        );
        const caratOptions = card.querySelectorAll(".caret-swatch-item");

        if (caratBtn && caratPopup) {
          caratBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            const isOpen = caratPopup.classList.contains("popup-visible");
            closeAllDropdowns();
            if (!isOpen) {
              openPopup(caratBtn, caratPopup);
              caratBtn.classList.add(
                "carat-swatches-parent-wrapper--button--upArrow",
              );
            }
          });

          caratOptions.forEach((opt) => {
            opt.addEventListener("click", (e) => {
              e.stopPropagation();
              selectedCarat = parseFloat(opt.dataset.swatchName);
              caratBtn.textContent = opt.dataset.swatchName;
              caratOptions.forEach((o) => o.classList.remove("active"));
              opt.classList.add("active");
              caratPopup.classList.remove("popup-visible");
              caratBtn.classList.remove(
                "carat-swatches-parent-wrapper--button--upArrow",
              );
              applyVariant(selectedSwatch, selectedKarat);
            });
          });
        }
      });
    }

    function openPopup(btn, popup) {
      const card = popup.closest("[data-product-id]");
      if (card) card.style.zIndex = "9999";
      popup.classList.add("popup-visible");
    }

    function closeAllDropdowns() {
      grid.querySelectorAll(".popup-visible").forEach((el) => {
        el.classList.remove("popup-visible");
        const card = el.closest("[data-product-id]");
        if (card) card.style.zIndex = "";
      });
      grid
        .querySelectorAll(
          ".metalKarat-swatches-parent-wrapper--button--upArrow",
        )
        .forEach((el) =>
          el.classList.remove(
            "metalKarat-swatches-parent-wrapper--button--upArrow",
          ),
        );
      grid
        .querySelectorAll(".carat-swatches-parent-wrapper--button--upArrow")
        .forEach((el) =>
          el.classList.remove("carat-swatches-parent-wrapper--button--upArrow"),
        );
    }

    // ── Load more ──────────────────────────────────────────────────────────────
    function renderLoadMore(data) {
      const hasLocalMore = currentPage * PAGE_SIZE < allResults.length;
      if (!data.hasMore && !hasLocalMore) {
        loadMoreWrap.innerHTML = "";
        return;
      }
      loadMoreWrap.innerHTML = `<a id="ais-load-more" class="btn btn--secondary no-transition" style="cursor:pointer;">Load More</a>`;
      document
        .getElementById("ais-load-more")
        .addEventListener("click", async () => {
          const start = currentPage * PAGE_SIZE;
          const end = start + PAGE_SIZE;
          currentPage++;
          if (start < allResults.length) {
            const nextPage = allResults.slice(start, end);
            const stillMore = end < allResults.length || data.hasMore;
            renderResults(nextPage, true);
            renderLoadMore({ ...data, hasMore: stillMore });
          } else {
            const params = new URLSearchParams({ page: currentPage });
            Object.entries(lastFilters).forEach(([k, v]) => {
              if (v != null) params.set(k, v);
            });
            const resp = await fetch(`${API}/api/page?${params}`);
            const d = await resp.json();
            allResults = allResults.concat(d.results || []);
            renderResults(d.results.slice(0, PAGE_SIZE), true);
            renderLoadMore(d);
          }
        });
    }

    function handleize(str) {
      return (str || "")
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");
    }

    function toKaratLabel(metalType) {
      const lower = (metalType || "").toLowerCase().trim();
      if (lower === "platinum") return "PL";
      const m = lower.match(/(\d+)\s*k/);
      return m ? `${m[1]}K` : "";
    }

    function setStatus(msg) {
      if (statusEl) statusEl.textContent = msg;
    }

    function setVoiceBtn(recording) {
      const btn = document.getElementById("ais-voice-btn");
      if (!btn) return;
      btn.innerHTML = recording
        ? `<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="6" width="12" height="12" rx="1"/></svg> Stop Recording`
        : `<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1a4 4 0 0 1 4 4v6a4 4 0 0 1-8 0V5a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v6a2 2 0 0 0 4 0V5a2 2 0 0 0-2-2zm7 8a1 1 0 0 1 1 1 8 8 0 0 1-7 7.938V21h2a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2h2v-1.062A8 8 0 0 1 4 12a1 1 0 0 1 2 0 6 6 0 0 0 12 0 1 1 0 0 1 1-1z"/></svg> Search by Voice`;
    }
  } // end init
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
